import { Tooltip } from '@mui/material';

import { IconCommentMS } from '../../../../../../constants/icons';
import { CommentsBadge, CommentsCellButton } from './styles';

interface CommentsCellProps {
  count: number;
  // Sem a credenciada não há endpoint para chamar: o indicador aparece, mas não
  // abre. A API já envia `licensed_company_id` no Fluxo (REAL-3192) — isto cobre
  // ambiente que ainda não subiu a versão.
  disabled: boolean;
  onOpen: () => void;
}

export function CommentsCell({
  count,
  disabled,
  onOpen,
}: CommentsCellProps): JSX.Element {
  const label = disabled
    ? 'Comentários indisponíveis nesta visualização'
    : 'Ver comentários';

  return (
    <Tooltip title={label}>
      <CommentsBadge badgeContent={count} invisible={count === 0}>
        <CommentsCellButton
          aria-label={label}
          disabled={disabled}
          onClick={(event) => {
            // A linha inteira navega para a análise; o clique aqui não deve.
            event.stopPropagation();
            onOpen();
          }}
        >
          {IconCommentMS}
        </CommentsCellButton>
      </CommentsBadge>
    </Tooltip>
  );
}
